/* eslint-disable max-params */
import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ArrowIcon from "../../../shared/arrow";
import Checkbox from "../../../shared/checkbox/component";
import styles from "./styles.css";
import SearchFilter from "../../search-filter";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import getAppliedFilter from "../../../../utils/filters-v2/get-applied-filter";
import Accordion from "../../../shared/accordion";
// import checkAllOptionStatus from "../../../../utils/filters-v2/check-all-option-status";
// import checkAnyOptionSelected from "../../../../utils/filters-v2/check-any-option-selected";
import { checkIfFilterExists } from "../../../../utils/filters-v2/get-updated-applied-filters";
import {updateFilterOptionData, updateSelectedSuggestions, updateAllSubFilterOptions, updateListingType, setListingFBEvents} from "../../filters/actions";
import { FB_EVENTS_CATEGORY } from "../../../../tracking/fb-events";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { NUMBER } from "../../../../constants/app-constants";
import { reloadCarList } from "../../car-listing/actions";
import getUpdatedAppliedFilters from "../../../../utils/filters-v2/get-updated-applied-filters";
import { AU_FILTER_EVENT, AU_FILTER_EVENTS_KEYS } from "../../../../tracking/au.mobile-filter-events";
import { yieldToMain } from "../../../../utils/helpers/yield-to-main";

// eslint-disable-next-line max-statements
const ModelFilterRevamp = ({
    updateFilterOptionDataConnect,
    selectedFilters,
    selectedSuggestions,
    updateSelectedSuggestionsConnect,
    updateAllSubFilterOptionsConnect,
    setListingFBEventsConnect,
    reloadCarListConnect,
    allFilters,
    getListingUrl
}) => {
    const filter = allFilters.make || {};
    const dropDownRef = useRef();
    const dropDownSearchedRef = useRef();
    const notFoundRef = useRef();
    const searchRef = useRef();

    const [filterOptions, setFilterOptions] = useState(filter.options || []);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [searchFocused, setSearchedFocused] = useState(false);

    const onChangeSubFilterOption = (filterKey, filterOptionKey, subFilterOptionKey, isSelectedValue, displayText) => {

        if (isSelectedValue) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_MODEL_SELECTED_ON, {eventLabel: `${subFilterOptionKey}`});
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_DESELECTED_CONTAINER, {eventLabel: `${subFilterOptionKey}`});
        }
        const data = {
            filterKey,
            optionKey: filterOptionKey,
            subOptionKey: subFilterOptionKey,
            isSelected: isSelectedValue,
            displayText,
            isAllModelVariant: true
        };
        updateFilterOptionDataConnect(data);
        // Remove option from suggestions also if unselected and option exists in selected suggestions
        if (!isSelectedValue && checkIfFilterExists({filterKey, optionKey: filterOptionKey, subOptionKey: subFilterOptionKey}, selectedSuggestions)) {
            updateSelectedSuggestionsConnect({
                filterKey,
                optionKey: filterOptionKey,
                subOptionKey: subFilterOptionKey,
                isSelected: false,
                displayText
            });
        }
        setListingFBEventsConnect(isSelectedValue ? FB_EVENTS_CATEGORY.LISTING_PAGE_MAKE_MODEL : "");
        const updateFiter = getUpdatedAppliedFilters(data, selectedFilters);
        getListingUrl(updateFiter);
        reloadCarListConnect(true);
    };

    const onSearchHandler = (filteredItems, searchTerm) => {
        trackDesktopCustomEventsAU(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_MODEL_SEARCH, {
            ...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_MODEL_SEARCH],
            eventLabel: searchTerm});
        setFilterOptions(filteredItems);
        setSearchKeyword(searchTerm);
    };

    const onChangeAllSubOptions = (filterKey, optionKey, isSelected) => {
        if (isSelected) {
            trackDesktopCustomEventsAU(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_SELECTED, {
                ...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_SELECTED],
                eventLabel: optionKey});
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_DESELECTED_CONTAINER, {eventLabel: `${optionKey}`});
        }
        setListingFBEventsConnect(FB_EVENTS_CATEGORY.LISTING_PAGE_MAKE);
        const data = {
            filterKey, optionKey,
            isSelected,
            displayText: optionKey,
            isAllModelVariant: true
        };
        updateAllSubFilterOptionsConnect(data);
        const updateFiter = getUpdatedAppliedFilters(data, selectedFilters);
        getListingUrl(updateFiter);
        reloadCarListConnect(true);
    };

    useEffect(() => {
        setFilterOptions(filter.options || []);
    }, [filter.options]);

    const arrowExpandHandler = async (isCollapsed, modelName) => {
        await yieldToMain();
        if (isCollapsed) {
            trackDesktopCustomEventsAU(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_ON, {
                ...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_ON],
                eventLabel: modelName});
        } else {
            trackDesktopCustomEventsAU(AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_OFF,
                {...AU_FILTER_EVENT[AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_OFF],
                    eventLabel: modelName});
        }
    };

    const handleSearchFocus = () => {
        setSearchedFocused(true);
    };

    const handleBlur = () => {
        setSearchedFocused(!searchFocused);
    };

    const handleClose = () => {
        setSearchedFocused(false);
        setSearchKeyword("");
        setFilterOptions(filter.options);
    };

    const checkOptionSelected = (item) => {
        const obj = {isAllOptionSelected: false, isAnyOptionSelected: false };
        const allOptions = allFilters.make && allFilters.make.options;
        const model =  allOptions.find(it => it.key.toLowerCase() === item.toLowerCase());
        const modelOptions = (model.subFilter && model.subFilter.options) || [];
        const filterMatched = selectedFilters.length ? selectedFilters.filter(it =>  (it.optionKey || "").toLowerCase() === item.toLowerCase()) : [];
        const isModelAvailable = selectedFilters.find(it => (it.optionKey || "").toLowerCase() === item.toLowerCase() && it.subOptionKey);        if (selectedFilters.length === 0) {
            obj.isAllOptionSelected = false;
            obj.isAnyOptionSelected = false;
        } else if (isModelAvailable && (modelOptions.length !== filterMatched.length)) {
            obj.isAnyOptionSelected = true;
        } else if ((modelOptions.length === filterMatched.length) || !isModelAvailable && filterMatched.length) {
            obj.isAllOptionSelected = true;
        }
        return obj;
    };

    return (
        <React.Fragment>
            <div styleName={"styles.makeModelWrap"}>
                <div styleName="styles.makeModelSearchWrap">
                    <div styleName={"styles.searchFilterWrapper"} ref={searchRef}>
                        <SearchFilter
                            placeholder={"Search by Brand or Model"}
                            searchItems={filter.options}
                            onSearchHandler={onSearchHandler}
                            showClearIcon={true}
                            searchIconType = "blue"
                            inputProps={{
                                onFocus: handleSearchFocus,
                                onClick: handleSearchFocus
                            }}
                            onCloseCallback={handleClose}
                            searchFocused={searchFocused}
                        />

                    </div>
                    { filterOptions.length > 0 && searchKeyword === "" && searchFocused &&
                    <React.Fragment>
                        <div styleName={"styles.searchDropDownContainer"} ref={dropDownRef} onBlur={handleBlur}>
                            {/* <h5 styleName="styles.model-filter-heading">All Brands</h5> */}
                            {(filterOptions).map((filterOption, filterOptionIndex) => {
                                const {isAllOptionSelected, isAnyOptionSelected} = checkOptionSelected(filterOption.key);
                                return (

                                    <Accordion key={filterOptionIndex} toggleAll={true} collapseAccordion={true} totalItems={filterOptions.length}>
                                        {({ onClick, currentVisibleStates }) => (
                                            <Accordion.Content>
                                                <div key={filterOption.key} styleName={"styles.accordianWrap"}>
                                                    <Accordion.Heading>
                                                        <div styleName={"styles.accordianHeading"}>
                                                            <div styleName={(!isAllOptionSelected && isAnyOptionSelected) ? "partialChecked" : ""}>
                                                                <Checkbox
                                                                    checkedStatus={isAllOptionSelected}
                                                                    onChange={onChangeAllSubOptions.bind(null, filter.key, filterOption.key, !isAllOptionSelected)}
                                                                    id={`option_${filterOption.key}`}
                                                                    name={`option_${filterOption.key}`}
                                                                />
                                                            </div>

                                                            <div onClick={() => onClick({ index: filterOptionIndex })} styleName={"styles.headingWrap"}>
                                                                <h3 styleName={"styles.modelName"}>{filterOption.displayText}</h3>
                                                            </div>
                                                            <ArrowIcon blue = {"BlueArrow"} onClick={() => {
                                                                onClick({ index: filterOptionIndex });
                                                                arrowExpandHandler(currentVisibleStates[filterOptionIndex], filterOption.displayText);
                                                            }} rotateBy={currentVisibleStates[filterOptionIndex] ? NUMBER.ZERO : NUMBER.ONE_HUNDRED_EIGHTY } />
                                                        </div>
                                                    </Accordion.Heading>
                                                    <Accordion.Body>
                                                        {
                                                            !currentVisibleStates[filterOptionIndex] && (
                                                                <div styleName={"styles.accordianContent"}>
                                                                    <ul styleName={"styles.selectModelName"}>
                                                                        <li key={`sub_option_all_model_${filterOption.key}`}>
                                                                            <Checkbox
                                                                                checkedStatus={isAllOptionSelected}
                                                                                onChange={onChangeAllSubOptions.bind(null, filter.key, filterOption.key, !isAllOptionSelected)}
                                                                                name={`sub_option_all_model_${filterOption.key}`}
                                                                                id={`sub_option_all_model_${filterOption.key}`}
                                                                            />
                                                                            {"All models"}
                                                                        </li>
                                                                        {
                                                                            filterOption.subFilter.options.map((subFilterOption) => {
                                                                                const isSelected = !!getAppliedFilter({filterKey: filter.key, optionKey: filterOption.key, subOptionKey: subFilterOption.key}, selectedFilters);
                                                                                return (
                                                                                    <li key={`sub_option_${subFilterOption.key}`}>
                                                                                        <Checkbox
                                                                                            checkedStatus={isSelected}
                                                                                            onChange={onChangeSubFilterOption.bind(null, filter.key, filterOption.key, subFilterOption.key, !isSelected, subFilterOption.displayText)}
                                                                                            id={`sub_option_${subFilterOption.key}`}
                                                                                            name={`sub_option_${subFilterOption.key}`}/>
                                                                                        {subFilterOption.displayText}
                                                                                    </li>
                                                                                );
                                                                            })
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            )
                                                        }

                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Content>
                                        )}
                                    </Accordion>
                                );
                            })}
                        </div>
                    </React.Fragment>
                    }

                    { filterOptions.length > 0 && searchKeyword !== "" && searchFocused &&
                        <div styleName={"styles.searchDropDownContainer"} ref={dropDownSearchedRef} onBlur={handleBlur}>
                            <h5 styleName="styles.model-filter-heading">All Brands</h5>
                            {(filterOptions).map((filterOption, filterOptionIndex) => {
                                const {isAllOptionSelected, isAnyOptionSelected} = checkOptionSelected(filterOption.key);

                                return (
                                    <Accordion key={filterOptionIndex} toggleAll={true} collapseAccordion={false} totalItems={filterOptions.length}>
                                        {({ onClick, currentVisibleStates }) => (
                                            <Accordion.Content>
                                                <div key={filterOption.key} styleName={"styles.accordianWrap"}>
                                                    <Accordion.Heading>
                                                        <div styleName={"styles.accordianHeading"}>
                                                            <div styleName={(!isAllOptionSelected && isAnyOptionSelected) ? "partialChecked" : ""}>
                                                                <Checkbox
                                                                    checkedStatus={isAllOptionSelected}
                                                                    onChange={onChangeAllSubOptions.bind(null, filter.key, filterOption.key, !isAllOptionSelected)}
                                                                    id={`option_${filterOption.key}`}
                                                                    name={`option_${filterOption.key}`}
                                                                />
                                                            </div>

                                                            <div onClick={() => onClick({ index: filterOptionIndex })} styleName={"styles.headingWrap"}>
                                                                <h3 styleName={"styles.modelName"}>{filterOption.displayText}</h3>
                                                            </div>
                                                            <ArrowIcon  blue={"BlueArrow"}
                                                                onClick={() => {
                                                                    onClick({ index: filterOptionIndex });
                                                                    arrowExpandHandler(currentVisibleStates[filterOptionIndex], filterOption.displayText);
                                                                }} rotateBy={currentVisibleStates[filterOptionIndex] ?  NUMBER.ZERO : NUMBER.ONE_HUNDRED_EIGHTY } />
                                                        </div>
                                                    </Accordion.Heading>
                                                    <Accordion.Body>
                                                        {
                                                            !currentVisibleStates[filterOptionIndex] && (
                                                                <div styleName={"styles.accordianContent"}>
                                                                    <ul styleName={"styles.selectModelName"}>
                                                                        <li key={`sub_option_all_model`}>
                                                                            <Checkbox
                                                                                checkedStatus={isAllOptionSelected}
                                                                                onChange={onChangeAllSubOptions.bind(null, filter.key, filterOption.key, !isAllOptionSelected)}                                                                                            id={`sub_option_all_model`}
                                                                                name={`sub_option_all_model`}/>
                                                                            {"All models"}
                                                                        </li>

                                                                        {
                                                                            filterOption.subFilter.options.map((subFilterOption) => {
                                                                                const isSelected = !!getAppliedFilter({filterKey: filter.key, optionKey: filterOption.key, subOptionKey: subFilterOption.key}, selectedFilters);
                                                                                return (
                                                                                    <li key={`sub_option_${subFilterOption.key}`}>
                                                                                        <Checkbox
                                                                                            checkedStatus={isSelected}
                                                                                            onChange={onChangeSubFilterOption.bind(null, filter.key, filterOption.key, subFilterOption.key, !isSelected, subFilterOption.displayText)}
                                                                                            id={`sub_option_${subFilterOption.key}`}
                                                                                            name={`sub_option_${subFilterOption.key}`}/>
                                                                                        {subFilterOption.displayText}
                                                                                    </li>
                                                                                );
                                                                            })
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            )
                                                        }

                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Content>
                                        )}
                                    </Accordion>
                                );
                            })}
                        </div>
                    }

                    { filterOptions.length === 0 && searchFocused &&
                    <div styleName="styles.notFoundContainer" ref={notFoundRef}>
                        <p styleName="styles.notFOundHeading">Make/Model not found</p>
                        <p styleName="styles.notFOundSubHeading">We don’t have make/model you are looking for, please ensure your keyword is correct {searchKeyword} </p>
                    </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

ModelFilterRevamp.propTypes = {
    filter: PropTypes.object,
    selectedFilters: PropTypes.array,
    selectedSuggestions: PropTypes.array,
    updateFilterOptionDataConnect: PropTypes.func,
    updateSelectedSuggestionsConnect: PropTypes.func,
    updateAllSubFilterOptionsConnect: PropTypes.func,
    updateListingTypeConnect: PropTypes.func,
    email: PropTypes.string,
    setListingFBEventsConnect: PropTypes.func,
    allFilters: PropTypes.array,
    reloadCarListConnect: PropTypes.func,
    getListingUrl: PropTypes.func
};

const mapStateToProps = ({
    filters: {
        selectedFilters,
        selectedSuggestions,
        allFilters
    },
    user: { email }
}) => ({
    selectedFilters,
    selectedSuggestions,
    email,
    allFilters
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateFilterOptionDataConnect: updateFilterOptionData,
    updateSelectedSuggestionsConnect: updateSelectedSuggestions,
    updateAllSubFilterOptionsConnect: updateAllSubFilterOptions,
    updateListingTypeConnect: updateListingType,
    setListingFBEventsConnect: setListingFBEvents,
    reloadCarListConnect: reloadCarList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ModelFilterRevamp);
